import { Outlet } from 'react-router-dom'
import { useAuth } from '@/context/AuthContext'
import { ResultToastProvider } from '@/context/ResultToastContext'
import { AdminHeader } from './AdminHeader'

export function AppLayout() {
  const { isDemo } = useAuth()

  return (
    <ResultToastProvider>
    <div className="admin-shell">
      <AdminHeader />
      <div className="admin-shell__body">
        <div className="content admin-shell__content m-0 p-0 ms-2 me-2" id="CrmAppContent">
          {isDemo && (
            <div className="demo-strip">
              Preview workspace · Sample data · Changes saved in this browser session
            </div>
          )}
          <div className="admin-page">
            <Outlet />
          </div>
        </div>
        <footer className="admin-shell__footer">
          <div className="admin-footer">
            <span>SmoothBadger CRM</span>
            <span>Customer workspace</span>
          </div>
        </footer>
      </div>
    </div>
    </ResultToastProvider>
  )
}
